import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconComment$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconComment extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '5fb4cd3036c17bb24a66eb777e11170946b37fd7', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'f66c683aec8bc15d55ceb14a74290b008ecd3e17', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '95959d28ed78116f35fa9c3d466a8eda19e4c58d', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M20 3H2.5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5H7v4.36a.3.3 0 0 0 .49.23L13 15h6.5a.5.5 0 0 0 .5-.5zM3.5 4.5h15v9h-5.86a.47.47 0 0 0-.32.12L8.5 16.8V14a.5.5 0 0 0-.5-.5H3.5zM7 7.89A1.11 1.11 0 0 0 5.89 9 1.07 1.07 0 0 0 7 10.11 1.07 1.07 0 0 0 8.11 9 1.11 1.11 0 0 0 7 7.89M9.89 9a1.11 1.11 0 1 1 2.22 0 1.11 1.11 0 0 1-2.22 0M15 7.89a1.11 1.11 0 1 0 0 2.22 1.11 1.11 0 0 0 0-2.22", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-comment", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-comment"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-comment":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconComment$1);
            }
            break;
    } });
}

const CosmosIconComment = CosmosIconComment$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconComment, defineCustomElement };
